import {
  Resource,
  List,
  Datagrid,
  BulkDeleteButton,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  FunctionField,
} from "react-admin";
import { CrudPermissions } from "../../auth/crud-permissions";
import WebIcon from "@mui/icons-material/Web";
import { PaidSourceInput } from "./paid-source-input";
import { getPaidSourceName } from "./paid-source-name";
import { TopHelpInfoText } from "../../help/top-help-info-text";

export const TrackedUrlResource = (perms: CrudPermissions) => {
  return (
    <Resource
      name="tracked-url"
      key={"tracked-url"}
      options={{
        label: "Tracked URLs",
      }}
      list={TrackedUrlList(perms)}
      edit={perms.update ? TrackedUrlEdit : undefined}
      create={perms.create ? TrackedUrlCreate : undefined}
      icon={WebIcon}
    />
  );
};

export const TrackedUrlList = (perms: CrudPermissions) => {
  return (
    <>
      <TopHelpInfoText text="Configure URL prefixes to associate with breakdowns for tracking and optional URL rewriting." />
      <List>
        <Datagrid
          rowClick={perms.update ? "show" : false}
          bulkActionButtons={perms.delete ? <BulkDeleteButton /> : false}
        >
          <FunctionField
            label="Breakdown"
            // eslint-disable-next-line
            render={(record) => getPaidSourceName(record.paidSource)}
          />
          <TextField source="urlPrefix" label="URL Prefix" />
          <TextField source="replacementPrefix" label="Replacement URL" />
        </Datagrid>
      </List>
    </>
  );
};

const replacementTextInput = () => (
  <TextInput
    source="replacementPrefix"
    label="Replacement URL"
    helperText="If this is set, the proxy will replace the matches of the URL prefix with this value. Any mapped phone numbers for this breakdown will also be injected."
    fullWidth
  />
);

export const TrackedUrlEdit = () => {
  return (
    <Edit redirect="list">
      <SimpleForm>
        <PaidSourceInput />
        <TextInput source="urlPrefix" label="URL Prefix" fullWidth />
        {replacementTextInput()}
      </SimpleForm>
    </Edit>
  );
};

export const TrackedUrlCreate = () => {
  return (
    <Create redirect="list">
      <SimpleForm>
        <PaidSourceInput />
        <TextInput source="urlPrefix" label="URL Prefix" fullWidth />
        {replacementTextInput()}
      </SimpleForm>
    </Create>
  );
};
